import React from "react";
import PropTypes from "prop-types";
import Slider from "rc-slider";

const AlmigSlider = props => (
	<Slider value={props.value} step={props.step}
		min={props.min} max={props.max}
		onChange={props.setValue} />
);

AlmigSlider.propTypes = {
	value: PropTypes.number,
	step: PropTypes.number,
	min: PropTypes.number.isRequired,
	max: PropTypes.number.isRequired,
	setValue: PropTypes.func.isRequired
};

export default AlmigSlider;
